"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Returns a DOM node from the view.
 *
 * @param {Object} view
 * @param {string} selector
 * @returns {Object}
 */
var getEl = function (view, selector) {
  var matches = view.$(selector);

  if (matches && matches.length > 0) {
    return matches[0];
  }

  return undefined;
};

var _default = getEl;
exports.default = _default;